import './logo.scss'

const Logo = ({ className, ...props }) => {
    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1767.9 675.8"
            className={className}
            {...props}
        >
            <g>
                <path
                    fill="#005DAC"
                    d="M169.7,249.2l28.6-18.2c3-1.9,6.8,0.2,6.8,3.7v71.2c6.9-12.7,24.4-24.9,47.9-24.9c30.2,0,59,20.2,59,63.2v88.4
                    c0,3.1-2.5,5.5-5.5,5.5h-38c-3.1,0-5.5-2.5-5.5-5.5v-75.4c0-20.2-10.3-31.6-26.9-31.6c-17.5,0-29.9,13-29.9,32.7v74.3
                    c0,3.1-2.5,5.5-5.5,5.5h-37.7c-3.1,0-5.5-2.5-5.5-5.5V271.6C157.4,262.5,162,254,169.7,249.2"
                />
            </g>

            <g>
                <path
                    fill="#0096FA"
                    d="M1369.8,346.5h71.5c-3.9-17.2-16.6-28.3-34.9-28.3C1388.7,318.2,1374.8,328.7,1369.8,346.5 M1476.9,377.5
                    h-106.8c4.7,16.6,17.7,28.5,41.3,28.5c14.4,0,30.7-4.9,42.7-11.8c2.7-1.5,6-0.6,7.6,2l11.8,20.3c1.5,2.5,0.7,5.8-1.7,7.4
                    c-14.8,9.8-36.6,18.1-62.3,18.1c-56.8,0-83.1-38.2-83.1-79.5c0-45.2,31.9-79.5,80.1-79.5c43.5,0,76.8,28,76.8,76.2
                    c0,4.5-0.3,8.9-0.8,13.4C1482.1,375.4,1479.7,377.5,1476.9,377.5"
                />
            </g>

            <g>
                <path
                    fill="#0096FA"
                    d="M1610.2,425.8c0.9,2.6-0.2,5.5-2.6,6.7c-11.9,6.3-27.8,10.1-42.4,10.1c-35.5,0-54.3-20.5-54.3-61.2v-58.5
                    h-18.6c-3.1,0-5.5-2.5-5.5-5.5v-24.9c0-3.1,2.5-5.5,5.5-5.5h18.8v-14.7c0-9.8,5.4-18.8,14-23.5l22.7-12.1c3-1.6,6.5,0.6,6.5,3.9
                    v46.4h43.2c3.1,0,5.5,2.5,5.5,5.5v24.9c0,3.1-2.5,5.5-5.5,5.5h-43.2v54.3c0,17.5,6.7,25.8,20.2,25.8c7.4,0,13.6-2.1,19.5-4.8
                    c3-1.4,6.4,0.1,7.5,3.2L1610.2,425.8z"
                />
            </g>

            <g>
                <path
                    fill="#005DAC"
                    d="M611.9,359.9c0-20-14.7-34.6-34.6-34.6c-20,0-34.6,14.4-34.6,34.6c0,20.5,14.7,35.5,34.6,35.5
                    C597.2,395.4,611.9,380.1,611.9,359.9 M651.3,273.2c3-1.9,6.8,0.2,6.8,3.7v145.6c0,49.6-38,79.5-87,79.5
                    c-25.5,0-50.3-8.2-68.4-20.2c-2.3-1.5-3.1-4.6-1.8-7l12.9-26c1.4-2.9,5-3.9,7.8-2.3c13,7.6,29.5,14.3,47.6,14.3
                    c28.8,0,42.4-16.1,42.4-35.2v-3.3c-9.7,9.1-23.6,15.2-42.7,15.2c-46,0-75.6-32.7-75.6-78.1c0-47.7,34.1-79,77.9-79
                    c18.6,0,32.7,6.9,43,16.6l14.6-9.3L651.3,273.2z"
                />
            </g>

            <g>
                <path
                    fill="#005DAC"
                    d="M1642.7,422.5h2.5c1.6,0,2.6-0.1,3-0.2c0.4-0.1,0.7-0.4,0.9-0.7c0.2-0.3,0.3-0.7,0.3-1.2c0-0.5-0.1-1-0.4-1.3
                    c-0.3-0.3-0.7-0.6-1.3-0.6c-0.3,0-1.1-0.1-2.4-0.1h-2.6V422.5z M1639.3,431.9v-16.2h7c1.8,0,3.1,0.1,3.9,0.4
                    c0.8,0.3,1.4,0.8,1.9,1.6c0.5,0.7,0.7,1.6,0.7,2.6c0,1.2-0.4,2.2-1.1,3c-0.7,0.8-1.8,1.3-3.3,1.5c0.7,0.4,1.3,0.9,1.8,1.4
                    c0.5,0.5,1.1,1.4,1.9,2.6l2,3.2h-4l-2.4-3.5c-0.9-1.3-1.4-2.1-1.8-2.4c-0.3-0.3-0.7-0.6-1-0.7c-0.4-0.1-0.9-0.2-1.7-0.2h-0.7v6.8
                    H1639.3z"
                />
            </g>

            <g>
                <path
                    fill="#005DAC"
                    d="M1646.4,411.4c-7.2,0-13.1,5.8-13.1,12.8c0,7.1,5.9,12.8,13.1,12.8c7.2,0,13.1-5.8,13.1-12.8
                    C1659.5,417.2,1653.7,411.4,1646.4,411.4 M1646.4,439.8c-8.7,0-15.8-7-15.8-15.5c0-8.6,7.1-15.5,15.8-15.5c8.7,0,15.8,7,15.8,15.5
                    C1662.3,432.8,1655.2,439.8,1646.4,439.8"
                />
            </g>

            <g>
                <path
                    fill="#005DAC"
                    d="M895.1,343h64.8c-4.2-14.4-15.5-23.6-31.9-23.6C912.2,319.4,900,327.7,895.1,343 M1000,376.5H895.6
                    c5,14.4,17.2,24.1,37.4,24.1c14.1,0,29.9-4.7,41.6-11.2c2.7-1.5,6-0.6,7.6,2l13.7,23.6c1.5,2.6,0.7,5.9-1.8,7.5
                    c-15.4,9.8-37,18.1-63.2,18.1c-57.1,0-84.5-38-84.5-79.8c0-45.7,32.7-80.4,81.7-80.4c44.1,0,78.4,28,78.4,76.5
                    c0,4.7-0.3,9.7-1,14.9C1005.1,374.5,1002.8,376.5,1000,376.5"
                />
            </g>

            <g>
                <path
                    fill="#005DAC"
                    d="M1015.2,411.1l15.9-23.9c1.8-2.7,5.4-3.3,7.9-1.4c11.6,8.8,26,15.4,41.1,15.4c8.9,0,16.3-3,16.3-9.7
                    c0-3-1.7-5.8-8.3-8.6c-7.5-2.8-28.8-9.1-38-13.3c-18-8.3-28.5-21.3-28.5-41.6c0-28.8,24.7-48.5,63.2-48.5
                    c18.7,0,36.1,4.5,52.9,16.7c2.4,1.8,3,5.1,1.4,7.5l-15.3,23.3c-1.6,2.5-4.9,3.2-7.5,1.7c-12.3-7.3-24.2-10.2-32.4-10.2
                    c-8,0-13.9,3.6-13.9,8.6c0,4.7,3,8.3,13.9,11.1c9.1,2.5,23.8,6.9,36,13.3c18.6,9.4,26,21.3,26,38.8c0,29.4-24.7,51-65.7,51
                    c-24.8,0-47.2-8.4-64.3-23.1C1014,416.5,1013.7,413.4,1015.2,411.1"
                />
            </g>

            <g>
                <path
                    fill="#005DAC"
                    d="M329.9,370.6v-80.6c0-3.1,2.5-5.5,5.5-5.5h38c3.1,0,5.5,2.5,5.5,5.5v81.2c0,7.6,2.2,13.7,6.7,18.4
                    c4.4,4.7,10.3,7.1,17.7,7.1c7.6,0,13.6-2.3,18-6.9c4.4-4.6,6.7-10.8,6.7-18.6v-81.2c0-3.1,2.5-5.5,5.5-5.5h38
                    c3.1,0,5.5,2.5,5.5,5.5v80.6c0,22.4-6.5,39.7-19.5,52.1c-13,12.4-31.1,18.6-54.2,18.6c-23.1,0-41.1-6.2-54-18.6
                    C336.3,410.3,329.9,392.9,329.9,370.6"
                />
            </g>

            <g>
                <path
                    fill="#0096FA"
                    d="M1272.7,438c-3.1,0-5.5-2.5-5.5-5.5l0-78.4c0-16.9-13.7-30.6-30.6-30.6c-5.9,0-11.7,1.6-17.3,4.8
                    c-7.3,4.2-13.3,14.7-13.3,23.3v80.8c0,3.1-2.5,5.5-5.5,5.5h-33.3c-3.1,0-5.5-2.5-5.5-5.5V346l0.1,0l0-1.3
                    c1.6-34.5,34.5-61.6,75-61.6c39.4,0,72.4,26.3,74.9,59.9l0.1,1.1l0.1,0.1v88.3c0,3.1-2.5,5.5-5.5,5.5H1272.7z"
                />
            </g>

            <g>
                <path
                    fill="#0096FA"
                    d="M1295,166.6l-61.9,44c-1.1,0.8-2.4,1.4-3.7,1.9c-1.4,0.5-2.8,0.8-4.2,1c-1.4,0.2-2.9,0.2-4.2,0
                    c-1.3-0.2-2.6-0.5-3.7-1l-53.9-26.1c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1-0.1
                    c-0.9-0.5-1.5-1.1-1.8-1.7c-0.4-0.7-0.5-1.4-0.3-2.1c0.1-0.7,0.5-1.5,1.1-2.2c0.6-0.7,1.4-1.5,2.5-2.1l61.6-39.5L1295,166.6z"
                />
            </g>

            <g>
                <path
                    fill="#0096FA"
                    d="M1255.7,97.7l-82.4,51.1l-45.5-20.1c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1
                    c-0.1,0-0.1-0.1-0.2-0.1c-1.5-0.8-2.6-1.8-3.2-2.9c-0.6-1.1-0.7-2.3-0.4-3.5c0.3-1.2,1.1-2.5,2.2-3.8c1.2-1.2,2.8-2.5,4.7-3.6
                    l53.1-30.2c1.9-1.1,4-2,6.3-2.7c2.2-0.7,4.6-1.2,7-1.5c2.4-0.3,4.7-0.4,6.9-0.2c2.2,0.2,4.2,0.5,6,1.2L1255.7,97.7z"
                />
            </g>

            <g>
                <path
                    fill="#0096FA"
                    d="M1369.1,105.5c1,0.4,1.7,0.8,2.3,1.3c0.6,0.5,0.9,1.1,1,1.7c0.1,0.6,0,1.2-0.3,1.8c-0.3,0.6-0.9,1.2-1.7,1.8
                    l-52.9,37.5l-68.9-26.5l53.1-34c0.8-0.5,1.8-1,2.9-1.3c1.1-0.3,2.2-0.6,3.4-0.7c1.2-0.1,2.4-0.2,3.5-0.1c1.1,0.1,2.2,0.3,3.2,0.6
                    l53.8,17.7c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0C1369,105.5,1369,105.5,1369.1,105.5"
                />
            </g>

            <g>
                <path
                    fill="#0096FA"
                    d="M1433.2,161.1c2.4,1,4.4,2.2,5.9,3.5c1.5,1.4,2.5,2.9,3,4.4c0.5,1.6,0.4,3.2-0.2,4.8c-0.6,1.6-1.8,3.2-3.6,4.7
                    l-52.7,44.2c-2.1,1.7-4.6,3.2-7.5,4.3c-2.8,1.1-6,1.8-9.2,2.2c-3.2,0.4-6.5,0.4-9.6,0c-3.1-0.4-6.2-1.2-8.9-2.4l-63.3-27.9
                    l82.4-60.7l62.4,22.3c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0.1,0.3,0.1C1433,161,1433.1,161,1433.2,161.1"
                />
            </g>

            <g>
                <path
                    fill="#005DAC"
                    d="M690.1,249.2l28.6-18.2c3-1.9,6.8,0.2,6.8,3.7v71.2c6.9-12.7,24.4-24.9,47.9-24.9c30.2,0,59,20.2,59,63.2v88.4
                    c0,3.1-2.5,5.5-5.5,5.5h-38c-3.1,0-5.5-2.5-5.5-5.5v-75.4c0-20.2-10.3-31.6-26.9-31.6c-17.5,0-29.9,13-29.9,32.7v74.3
                    c0,3.1-2.5,5.5-5.5,5.5h-37.7c-3.1,0-5.5-2.5-5.5-5.5V271.6C677.8,262.5,682.4,254,690.1,249.2"
                />
            </g>
        </svg>
    );
};

export const HughesnetLogo = () => {

    return <div className="hughesnet-logo">
        <Logo />
    </div>
}